import { Fetch } from 'lib';
import type { PaymentGatewaySummary } from 'types';

type RequestResponses = {
  total: number;
  data: PaymentGatewaySummary[];
};

type RequestParameters = {
  searchKey: string;
  pageSize: number;
  pageNumber: number;
};

const searchPaymentGateways = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminPaymentGateway/searchPaymentGateways',
    params,
  });

export { searchPaymentGateways };
